var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Video, VideoOff } from "lucide-react";
import Tooltip from "./Tooltip";
var VideoAudioSwitch = function (_a) {
    var isVideoMode = _a.isVideoMode, onToggle = _a.onToggle, _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.showTooltip, showTooltip = _c === void 0 ? true : _c, _d = _a.tooltipPosition, tooltipPosition = _d === void 0 ? "left" : _d, className = _a.className, props = __rest(_a, ["isVideoMode", "onToggle", "size", "showTooltip", "tooltipPosition", "className"]);
    var iconSizes = { sm: 14, md: 16, lg: 20 };
    var tooltipContent = isVideoMode ? "Switch to Audio Mode" : "Switch to Video Mode";
    var switchComponent = (React.createElement("div", __assign({ className: "talkbot-switch ".concat(isVideoMode ? 'talkbot-switch--on' : 'talkbot-switch--off'), onClick: onToggle }, props),
        React.createElement("div", { className: "talkbot-switch-thumb ".concat(isVideoMode ? 'talkbot-switch-thumb--on' : 'talkbot-switch-thumb--off') }, !isVideoMode ? (React.createElement(Video, { size: iconSizes[size], style: { color: 'var(--tb-primary)' } })) : (React.createElement(VideoOff, { size: iconSizes[size], style: { color: '#64748b' } })))));
    if (showTooltip) {
        return (React.createElement(Tooltip, { content: tooltipContent, position: tooltipPosition }, switchComponent));
    }
    return switchComponent;
};
export { VideoAudioSwitch };
